import axios from 'axios'
import router from './src/router'
import Vue from 'vue'
const http = axios.create({
    baseURL:'https://www.fastmock.site/mock/42adde7c2cdb28c60715ce1a2bf8d93a/movibot/api/'
})
// http.interceptors.request.use(function (config) {
//     if(localStorage.getItem('token') && localStorage.getItem('id')){
//         config.headers.Authorization = 'Bearer ' + localStorage.getItem('token')
//     }
//     return config;
//   }, function (error) {
//     return Promise.reject(error);
//   });
 
// http.interceptors.response.use(function (response) {
//     return response;
//   }, function (error) {
//      if(error.response.status == 401 || error.response.status == 402){
//          router.push('/login')
//          Vue.prototype.$msg.fail(error.response.data.message)
//      }
//     return Promise.reject(error);
//   });


export default http


//////////////////
// WEBPACK FOOTER
// ./http.js
// module id = null
// module chunks = 